module.exports = __webpack_public_path__ + "img/b594401ae27c79b754bcecc914bfcc03.png";